module.exports = __webpack_public_path__ + "img/header-diamondJewelryEarrings.b5f6d73.webp";